import { useState } from "react";

export function Login({ onSubmit, error, busy }: { onSubmit: (key: string, remember: boolean) => void; error: string | null; busy: boolean }) {
  const [key, setKey] = useState("");
  const [remember, setRemember] = useState(false);
  return (
    <main className="login">
      <form
        className="card"
        onSubmit={(e) => {
          e.preventDefault();
          if (key.trim()) onSubmit(key.trim(), remember);
        }}
      >
        <h1>Nemo</h1>
        <p>Sign in with your account API key.</p>
        <div className="field">
          <div className="field-head">
            <label htmlFor="api-key">API key</label>
          </div>
          <input id="api-key" type="password" autoComplete="off" value={key} onChange={(e) => setKey(e.target.value)} placeholder="nemo_live_…" aria-invalid={!!error || undefined} aria-describedby={error ? "login-err" : undefined} />
          {error && <p className="error" role="alert" id="login-err">{error}</p>}
        </div>
        <label className="inline">
          <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} /> Remember me on this device
        </label>
        <p className="hint">Leave this off on shared or public computers. The key is then kept only until you close this tab.</p>
        <button className="btn primary" type="submit" disabled={!key.trim() || busy}>
          {busy ? "Checking…" : "Sign in"}
        </button>
      </form>
    </main>
  );
}
